export const ROLE_CUSTOMER_CONFIG_EDITOR = 'customer-config-editor';

export const CUSTOMER_CONFIG_EDITOR_ROLES = [ROLE_CUSTOMER_CONFIG_EDITOR];
